document.addEventListener('DOMContentLoaded', function () {
  var currentUrl = window.location.href.split('?')[0];
  var links = document.querySelectorAll('.flavour_block_c a');
  links.forEach(function (link) {
    var linkUrl = link.href.split('?')[0];
    if (currentUrl === linkUrl) {
      link.classList.add('active');
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.stickycta');
  window.addEventListener('scroll', function () {
    let scrollLimit = 1600;
    if (window.innerWidth < 768) {
      scrollLimit = 2500;
    }
    if (window.scrollY > scrollLimit) {
      if (sticky) sticky.classList.add('show');
      document.body.classList.add('move-chat');
    } else {
      if (sticky) sticky.classList.remove('show');
      document.body.classList.remove('move-chat');
    }
  });
});